/* eslint-disable react/prop-types */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import withStyles from 'isomorphic-style-loader/withStyles';
import React, { Component } from 'react';
import history from '@source/history';
import { YayasanLoyolaService } from '@api/services';
import { Row, Col, Button, Spin, Grid } from 'antd';
import { UIBanner, UICardProfile, UIInformation } from '@components';
import {
  LoadingOutlined,
  RightOutlined,
  LeftOutlined,
  InfoCircleOutlined,
  DownOutlined,
} from '@ant-design/icons';
import Carousel from 'nuka-carousel';
import ModalLogin from '../../../components/ModalLogin';
import styles from './Home.css';
import homeLabel from './language';
import Title from 'antd/lib/typography/Title';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

class Home extends Component {
  constructor(props) {
    let labels = homeLabel(props.language);
    super(props);
    this.state = {
      label: labels,
      initial: '',
      visibleLogin: false,
      token: undefined,
      userData: undefined,
      language: '',
      dataLanding: {},
      loadingContainer: false,
      pageSiswa: 4,
      pageInfo: 3,
      isRefresh: false,
    };
  }

  static get CONTAINER_STYLE() {
    return {
      position: 'relative',
      height: '100vh',
      width: '100%',
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'middle',
    };
  }

  static get CARD_STYLE() {
    return {
      height: '200px',
      width: '200px',
      paddingTop: '80px',
      textAlign: 'center',
      background: '#52C0F5',
      color: '#FFF',
      fontFamily: 'sans-serif',
      fontSize: '12px',
      textTransform: 'uppercase',
      borderRadius: '10px',
      boxSizing: 'border-box',
    };
  }

  componentDidMount() {
    this.setState(
      {
        userData: this.props.userData
          ? JSON.parse(this.props.userData)
          : undefined,
        token: this.props.token,
        language: this.props.language,
      },
      () => {
        this.handleInit();
      },
    );
  }

  handleInit = () => {
    this.setState({
      loadingContainer: true,
      isRefresh: false,
    });
    YayasanLoyolaService.homepageInit(this.state.language)
      .then(res => {
        if (res.data.data) {
          const data = res ? res.data.data : null;
          this.setState({
            dataLanding: data,
            loadingContainer: false,
          });
        } else {
          this.setState({
            dataLanding: res ? res.data.data : null,
            loadingContainer: false,
          });
        }
      })
      .catch(err => {
        if (err) {
          this.setState({
            isRefresh: true,
            loadingContainer: false,
          });
        }
      });
  };

  cancelLogin = () => {
    this.setState({
      visibleLogin: false,
    });
  };

  onClickLogin = isLogin => {
    this.setState({
      visibleLogin: isLogin,
    });
  };

  changePage = name => {
    if (name === 'profile') {
      this.setState({
        pageSiswa: this.state.pageSiswa + 4,
      });
    } else if (name === 'info') {
      this.setState({
        pageInfo: this.state.pageInfo + 3,
      });
    }
  };

  goToPage = data => {
    if (data.id == 3) {
      history.push('/Informasi/langkah-kedepan');
    } else {
      history.push('/Informasi/' + data.id);
    }
  };

  goToKekl = data => {
    if (data.id == -1) {
      history.push('/CeritaKEKL');
    } else {
      history.push('/CeritaKeklDetail/' + data.id);
    }
  };

  gotoProfile = data => {
    history.push(`/ProfilPengurus/detail/${data.id}`);
  };

  render() {
    const {
      visibleLogin,
      dataLanding = {},
      loadingContainer,
      pageSiswa,
      pageInfo,
      isRefresh,
      label,
      language,
    } = this.state;
    const loadingIcon = (
      <LoadingOutlined style={{ fontSize: 64, color: '#ef712b' }} />
    );
    return (
      <div className={styles.root}>
        <Spin indicator={loadingIcon} spinning={loadingContainer} size="large">
          {dataLanding && !isRefresh ? (
            <div>
              <UIBanner
                image
                listImage={dataLanding.listBanner ? dataLanding.listBanner : []}
                isMobile={this.props.isMobile}
              />
              <div className={styles.container}>
                <Row>
                  <Col xs={24} sm={12}>
                    <img
                      className={styles.imageContainer}
                      src={dataLanding.imageDescription}
                      alt="logoAlt"
                    />
                  </Col>
                  <Col
                    xs={24}
                    sm={12}
                    style={{ background: 'white', padding: '40px' }}
                  >
                    <Row gutter={[0, 8]}>
                      <Col span={24} style={{ marginBottom: '2em' }}>
                        <Title level={2} className="appTitle">
                          {label.foundation}
                        </Title>
                        <Title level={4} className="appTitle">
                          {dataLanding && dataLanding.subtitleLoyola
                            ? dataLanding.subtitleLoyola
                            : ''}
                        </Title>
                      </Col>
                      <Col span={24} style={{ textAlign: 'left' }}>
                        <span className={styles.textContent}>
                          {dataLanding && dataLanding.descriptionLoyola
                            ? dataLanding.descriptionLoyola
                            : ''}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className={styles.profileContainer}>
                <Row style={{ marginBottom: '2em' }}>
                  <Col className="gutter-row" span={24}>
                    <Title level={2} className="appTitle">
                      {label.profil}
                    </Title>
                    <Title level={4} className="appTitle">
                      {dataLanding.subtitleManagement}
                    </Title>
                  </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  {dataLanding.listPengurus &&
                    dataLanding.listPengurus.map(
                      (res, index) =>
                        index < pageSiswa && (
                          <Col
                            className="gutter-row"
                            xs={24}
                            md={12}
                            lg={6}
                            style={{ marginBottom: '30px' }}
                          >
                            <UICardProfile
                              isMobile={this.props.isMobile}
                              data={res}
                              language={language}
                              onClickButton={this.gotoProfile}
                            />
                          </Col>
                        ),
                    )}
                </Row>
                <Row justify="center" style={{ marginTop: '2em' }}>
                  {dataLanding.listPengurus &&
                    pageSiswa < dataLanding.listPengurus.length && (
                      <Button
                        className={styles.buttonStyle}
                        onClick={() => history.push('/ProfilPengurus')}
                      >
                        {label.more}
                        <DownOutlined style={{ marginLeft: '.5em' }} />
                      </Button>
                    )}
                </Row>
              </div>
              <div
                className={styles.infoContainer}
                style={{
                  backgroundImage:
                    dataLanding && dataLanding.imageBackroundInformasi,
                }}
              >
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  style={{ marginBottom: 46 }}
                >
                  <Col className="gutter-row" span={24}>
                    <Title level={2} className="appTitle">
                      {label.informasi}
                    </Title>
                  </Col>
                </Row>
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  style={{ textAlign: 'center' }}
                >
                  {dataLanding.listInformasi &&
                    dataLanding.listInformasi.map(
                      (res, index) =>
                        index < pageInfo && (
                          <Col
                            className="gutter-row"
                            xs={24}
                            md={this.props.isMobile ? 12 : 8}
                            lg={8}
                            style={{ marginBottom: '30px', cursor: 'pointer' }}
                            onClick={() => this.goToPage(res)}
                          >
                            <UIInformation data={res} />
                          </Col>
                        ),
                    )}
                </Row>
              </div>
              <div className={styles.keklContainer}>
                <Row style={{ marginBottom: 46 }}>
                  <Col className="gutter-row" span={24}>
                    <Title level={2} className="appTitle">
                      {label.cerita}
                    </Title>
                    <Title level={4} className="appTitle">
                      {dataLanding.subtitleKEKL}
                    </Title>
                  </Col>
                  <Col span={24}>
                    <CeritaKeklSection
                      data={dataLanding.listKEKL}
                      isMobile={this.props.isMobile}
                      language={language}
                      onKekl={e => this.goToKekl(e)}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : (
            <div
              style={{
                height: '100%',
                textAlign: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
              }}
            >
              <InfoCircleOutlined style={{ fontSize: 64, marginBottom: 30 }} />
              <br />
              {isRefresh ? (
                <Button onClick={() => this.handleInit()}>Reload</Button>
              ) : (
                label.dataKosong
              )}
            </div>
          )}
        </Spin>
        <div style={{ display: 'none' }}>
          <ModalLogin
            visible={visibleLogin}
            handleLogin={isLogin => this.onClickLogin(isLogin)}
            handleCancelLogin={() => this.cancelLogin()}
            hiddenButton
            tokenUser={this.state.token}
            isMobile={this.props.isMobile}
          />
        </div>
      </div>
    );
  }
}

const CeritaKeklSection = props => {
  const { isMobile, data = [], language, onKekl } = props;
  const screens = useBreakpoint();
  const currBreakpoint = Object.entries(screens)
    .filter(s => !!s[1])
    .map(e => e[0]);
  const slideBreakpoints = {
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
    xxl: 4,
  };
  const slidesToShow = isMobile ? 1 : slideBreakpoints[currBreakpoint[currBreakpoint.length - 1]];
  return (
    <>
      <Carousel
        style={{
          width: '100%',
          padding: isMobile ? '20px' : '20px 60px',
          display: 'inline-block',
        }}
        renderCenterLeftControls={({ previousSlide }) => (
          <SliderControl icon={LeftOutlined} onClick={previousSlide} />
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <SliderControl icon={RightOutlined} onClick={nextSlide} />
        )}
        withoutControls={false}
        transitionMode="scroll"
        cellAlign="left"
        slidesToShow={slidesToShow}
        slideIndex={0}
        renderBottomCenterControls={null}
      >
        {data.map((res, index) => (
          <div
            style={{
              height: '600px',
              padding: '20px 20px',
            }}
          >
            <UICardProfile
              isMobile={isMobile}
              data={res}
              isKekl
              language={language}
              onClickButton={onKekl}
            />
          </div>
        ))}
      </Carousel>
    </>
  );
};

const SliderControl = props => {
  const Icon = props.icon;
  return (
    <Button type="link" onClick={props.onClick} style={{padding: 0}}>
      <Icon
        style={{
          fontSize: '2em',
          color: '#11174C',
          fontWeight: 'bold',
        }}
      />
    </Button>
  );
};

export default withStyles(styles)(Home);
